import { ORM } from 'redux-orm'
import Playlist from './Playlist'
import Product from './Product'
import PlanEntry from './PlanEntry'
import PlanCategory from './PlanCategory'
import PlanSubcategory from './PlanSubcategory'
import FeaturedProduct from './FeaturedProduct'
import User from './User'
import PlaylistFollower from './PlaylistFollower'
import PlaylistEntries from './PlaylistEntries'
import Favorite from './Favorite'

export const orm = new ORM()
orm.register(
  Favorite,
  Product,
  PlanEntry,
  Playlist,
  PlaylistEntries,
  PlaylistFollower,
  PlanCategory,
  PlanSubcategory,
  FeaturedProduct,
  User
)

export default orm
